var map = {
	"./AmBank.png": 19735,
	"./Bank of Singapore.png": 68812,
	"./Bank_Rakyat_Malaysia.png": 410,
	"./BigPay.png": 19995,
	"./Boost.png": 34250,
	"./CIMB_Group.png": 19434,
	"./Citibank Singapore.png": 25218,
	"./DBS Bank.png": 72874,
	"./DBS PayLah.png": 34093,
	"./EZ-Link Wallet (SimplyGo).png": 78009,
	"./FavePay.png": 61353,
	"./GoPayz.png": 32825,
	"./GrabPay.png": 11671,
	"./HSBC Singapore.png": 90023,
	"./HSBC_Malaysia.png": 95247,
	"./HongLeongBank.png": 77022,
	"./ICBC.png": 26150,
	"./Instapay_eWallet.png": 25841,
	"./Instarem (Nium).png": 75028,
	"./MAE_by_Maybank2u.png": 65645,
	"./Maybank Singapore.png": 73364,
	"./Maybank.png": 41714,
	"./OCBC_Bank_Malaysia.png": 96649,
	"./POSB.png": 96187,
	"./Public_Bank_Berhad.png": 32778,
	"./RHB_Bank.png": 21510,
	"./Revolut.png": 37654,
	"./ShopeePay.png": 22695,
	"./Standard Chartered Singapore.png": 89236,
	"./Touch_n_Go_eWallet.png": 13835,
	"./Trust Bank.png": 26883,
	"./UOB_Malaysia.png": 51471,
	"./Wise_TransferWise.png": 76641,
	"./YouTrip.png": 57567,
	"./alliance.png": 65576,
	"./astropay.png": 95318,
	"./bbva.png": 7676,
	"./belo.png": 82387,
	"./bna.png": 11658,
	"./brubank.png": 71424,
	"./ciudad.png": 29855,
	"./credicoop.png": 80349,
	"./cuentadni.png": 16404,
	"./default-bank.png": 45729,
	"./fiwind.png": 95082,
	"./galicia.png": 65297,
	"./gxbank.png": 27276,
	"./lemon.png": 61458,
	"./macro.png": 4823,
	"./mastercard.png": 57967,
	"./mercadopago.png": 10563,
	"./naranja.png": 74738,
	"./otrobanco.png": 42926,
	"./pampa.png": 99508,
	"./patagonia.png": 20853,
	"./personalpay.png": 95849,
	"./prex.png": 88490,
	"./provincia.png": 76166,
	"./santander.png": 75227,
	"./supervielle.png": 16291,
	"./uala.png": 6352,
	"./visa.png": 87860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25410;